var _defs, _g, _g2, _g3, _polyline, _polyline2, _polyline3, _line, _polyline4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #28aee4;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        stroke: #134d65;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.04,
    y1: 69.84,
    x2: 85.04,
    y2: 100.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m62.9,69.84c0-2.48,4.96-4.48,11.07-4.48s11.07,2.01,11.07,4.48-4.96,4.48-11.07,4.48-11.07-2.01-11.07-4.48Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.9,
    y1: 69.84,
    x2: 62.9,
    y2: 100.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.04,77.46c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.04,85.08c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.04,92.71c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.04,100.33c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "54.52 85.08 54.52 92.71 54.52 100.33"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.37,85.08c0-2.48,4.96-4.48,11.07-4.48s11.07,2.01,11.07,4.48-4.96,4.48-11.07,4.48-11.07-2.01-11.07-4.48Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "32.36 85.08 32.36 92.71 32.36 100.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.51,92.71c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.51,100.33c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 115.57,
    y1: 54.6,
    x2: 115.57,
    y2: 85.08
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.43,54.6c0-2.48,4.96-4.48,11.07-4.48s11.07,2.01,11.07,4.48-4.95,4.48-11.07,4.48-11.07-2.01-11.07-4.48Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.43,
    y1: 54.6,
    x2: 93.43,
    y2: 85.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.57,62.22c0,2.48-4.95,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.57,69.84c0,2.48-4.95,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.57,77.46c0,2.48-4.95,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.57,85.08c0,2.48-4.95,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "115.57 85.08 115.57 92.71 115.57 100.33"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "93.42 85.08 93.42 92.71 93.42 100.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.57,92.71c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.57,100.33c0,2.48-4.96,4.48-11.07,4.48s-11.07-2.01-11.07-4.48"
  }))))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "20.82 27.34 20.82 112.97 129.01 112.97"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "122.94 107.14 128.77 112.97 122.94 118.8"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "14.99 33.17 20.82 27.34 26.65 33.17"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.37,
    y1: 70.94,
    x2: 115.72,
    y2: 27.18
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "111.45 34.69 116.83 27.18 107.82 25.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.25a957b9c4cb4c8f6779bf8c98c92e04.svg";
export { ForwardRef as ReactComponent };